export const SentryDSN = Object.freeze({
    frontend: 'https://6559444d87df42f08badf654bc1e4d63@sentry.io/1525867',
    vue: 'https://6559444d87df42f08badf654bc1e4d63@sentry.io/1525867',
    videopage: 'https://6219897ef8b5403e958e035c3f11c760@sentry.io/1526769',
    videoplayer: 'https://8dc5ab57c4764ea5978248b8508d9606@sentry.io/5191202',
    bblf: 'https://82a3b7874991401aaabb0e9c97a4a8d2@sentry.io/1525870',
});
